export var ModalSubjects;
(function (ModalSubjects) {
    ModalSubjects["ShouldDeleteCheckbox"] = "shouldDelete";
    ModalSubjects["ConfirmButton"] = "modal-confirm-button";
})(ModalSubjects || (ModalSubjects = {}));
//# sourceMappingURL=styleguide.enum.js.map